import { render, staticRenderFns } from "./CollabLiveController.vue?vue&type=template&id=eec89182&"
import script from "./CollabLiveController.vue?vue&type=script&lang=ts&"
export * from "./CollabLiveController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports